import { power } from './power.js';
import type { Sleep } from './types.js';
import { StudioError } from '#~/error/index.js';

/**
 * Put the specified device to sleep.
 *
 * @param deviceId - ID of the device to be put to sleep.
 */
export const sleep: Sleep = async (deviceId) => {
  try {
    await power(deviceId, false);
  } catch (cause) {
    throw new StudioError('Unable to put the device to sleep.', { cause });
  }
};
